import { useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { returnStripePublishable } from "functions";

let stripePromise = null;

/**
 * 🔄 Generic hook for OTHER external scripts (e.g., Analytics, Maps).
 * Do NOT use this for Stripe if you are using loadStripe().
 */
export function useScript(src, id) {
  useEffect(() => {
    if (document.getElementById(id)) return;

    const script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.async = true;
    script.defer = true;
    script.setAttribute("data-loaded", "true");

    document.body.appendChild(script);

    return () => {
      // Optional: Cleanup if the script is only needed for one specific component
      // const element = document.getElementById(id);
      // if (element) document.body.removeChild(element);
    };
  }, [src, id]);
}

/**
 * 🧠 Lazy-loaded Stripe Promise.
 * Only initializes Stripe the first time it is actually requested.
 */
export const getStripePromise = () => {
  const key = returnStripePublishable();

  if (!key) {
    console.warn("[Stripe] Publishable key is missing. Stripe will not initialize.");
    return null;
  }

  if (!stripePromise) {
    // loadStripe internally handles creating the <script> tag 
    // and ensuring it's only loaded once.
    stripePromise = loadStripe(key);
  }
  
  return stripePromise;
};